<template>
  <div class="pa-3 text-center">
    <v-app-bar app dense color="white" flat v-if="!loading" class="mt-3">
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <v-avatar><img :src="user.profile_picture" referrerpolicy="no-referrer" /> </v-avatar>
              <span class="mx-3 pt-3 align-middle" v-html="user.username"></span>
              <br />
              <span class="mx-3 pt-3 align-middle" style="font-size: 0.7rem">{{ user.email }}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="signOut">
            <v-list-item-title>
              <span class="mx-3 pt-3 align-middle">Deconnexion</span>
              <v-btn icon> <v-icon>mdi-logout</v-icon></v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-col style="max-width: 150px !important" class="px-0">
        <v-select
          item-
          style="width: 150px"
          @change="changeTable"
          class="px-1 fit"
          v-model="table"
          outlined
          hide-details="auto"
          dense
          :items="['Mariages, répétitions et techn', 'Concerts']"
        ></v-select>
      </v-col>

      <v-btn class="d-none d-lg-block d-print-block" icon @click="removeAllFilters"
        ><v-icon>mdi-filter-variant-remove</v-icon></v-btn
      >
      <v-btn class="d-none d-lg-block d-print-block ma-0 pa-0" icon @click="setIdFilter">iD</v-btn>
      <!-- <v-btn-toggle
        class="d-none d-lg-block d-print-block"
        
        borderless
        @change="filterYear($event)"
        v-model="yearFilter"
        dense
      > -->
      <v-btn-toggle
        class="d-none d-lg-block d-print-block"
        borderless
        v-model="yearFilter"
        @change="updateSelectableItems"
        dense
      >
        <v-btn value="2023">
          <span>2023</span>
        </v-btn>
        <v-btn value="2024">
          <span>2024</span>
        </v-btn>
        <v-btn value="2025">
          <span>2025</span>
        </v-btn>
        <v-btn value="2026">
          <span>2026</span>
        </v-btn>
        <v-btn value="2027">
          <span>2027</span>
        </v-btn>
      </v-btn-toggle>
      <v-spacer></v-spacer>
      <v-img
        @click="initAll"
        class="d-none d-sm-block d-print-block mr-3"
        max-height="100"
        max-width="200"
        src="../components/logoMini.png"
      ></v-img>
      <v-spacer></v-spacer>

      <v-badge
        offset-x="25"
        offset-y="8"
        class="d-none d-lg-block d-print-block"
        bordered
        color="error"
        :content="nbBcdCer"
        :value="nbBcdCer"
        bottom
        overlap
      >
        <v-btn text depressed small @click="goToBDC('bdc')"> BDC Cérémonies </v-btn>
      </v-badge>
      <v-badge
        offset-x="25"
        offset-y="8"
        class="d-none d-lg-block d-print-block mr-9"
        bordered
        color="error"
        :content="nbBcdObs"
        :value="nbBcdObs"
        bottom
        overlap
      >
        <v-btn text depressed small @click="goToBDC('bdcobs')"> BDC Obsèques </v-btn>
      </v-badge>

      <span class="text-caption">Montpellier {{ parisTime }}</span>
      <span class="ml-2 text-caption">Phuket {{ bangkokTime }}</span>
      <!-- <span class="ml-5 text-caption">Vegas {{ vegasTime }}</span> -->
    </v-app-bar>
    <!-- <v-btn @click="saveChangeDebounce">test samir</v-btn> -->
    <v-row align="center" justify="center" class="pb-5 d-lg-none" v-if="!loading">
      <v-col align="center" justify="center">
        <v-btn icon @click="removeAllFilters"><v-icon>mdi-filter-variant-remove</v-icon></v-btn>
        <!-- <v-btn-toggle
          borderless
          @change="filterYear($event)"
          v-model="yearFilter"
          dense
          
        > -->
        <v-btn-toggle borderless v-model="yearFilter" @change="updateSelectableItems" dense>
          <v-btn value="2021">
            <span>2021</span>
          </v-btn>
          <v-btn value="2022">
            <span>2022</span>
          </v-btn>
          <v-btn value="2023">
            <span>2023</span>
          </v-btn>
          <v-btn value="2024">
            <span>2024</span>
          </v-btn>
          <v-btn value="2025">
            <span>2025</span>
          </v-btn>
        </v-btn-toggle>
        <v-badge
          bordered
          color="error"
          :content="nbBcdCer"
          :value="nbBcdCer"
          bottom
          overlap
          class="mr-3"
        >
          <v-btn text depressed @click="goToBDC('bdc')"> BDC Cérémonies </v-btn>
        </v-badge>
        <v-badge
          bordered
          color="error"
          :content="nbBcdObs"
          :value="nbBcdObs"
          bottom
          overlap
          class="ml-2"
        >
          <v-btn text depressed @click="goToBDC('bdcobs')"> BDC Obsèques </v-btn>
        </v-badge>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" style="height: 100vh" v-if="loading">
      <v-img max-height="1500" max-width="250" src="../components/AnimationLogo.gif"></v-img>
    </v-row>
    <template>
      <v-data-table
        ref="dataTable"
        v-if="!loading"
        height="83vh"
        item-key="row"
        dense
        multi-sort
        :search="search"
        :headers="headers"
        :items="dataFc"
        :items-per-page="-1"
        class="elevation-1 mt-8"
        fixed-header
        :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        @dblclick:row="openForm2"
      >
        <template v-slot:[`item.shorts`]="{ item }">
          <v-icon small class="mr-2 my-4" @click="openForm(item)"> mdi-pencil </v-icon>
        </template>
        <template v-slot:[`item.${montantVente}`]="{ item }">
          {{ calcul(montantVente, item) }}
        </template>
        <template v-slot:[`item.${tva}`]="{ item }">
          {{ calcul(tva, item) }}
        </template>
        <template v-slot:[`item.${margeBrute}`]="{ item }">
          {{ calcul(margeBrute, item) }}
        </template>
        <template v-slot:[`item.${envoi4mois}`]="{ item }">
          {{ calcul(envoi4mois, item) }}
        </template>
        <template v-slot:[`item.${envoi2mois}`]="{ item }">
          {{ calcul(envoi2mois, item) }}
        </template>
        <template v-slot:[`item.${envoi6semaine}`]="{ item }">
          {{ calcul(envoi6semaine, item) }}
        </template>
        <template v-slot:[`item.${envoi1mois}`]="{ item }">
          {{ calcul(envoi1mois, item) }}
        </template>
        <template v-slot:[`item.${envoi3semaine}`]="{ item }">
          {{ calcul(envoi3semaine, item) }}
        </template>
        <template v-slot:[`item.${envoi3jours}`]="{ item }">
          {{ calcul(envoi3jours, item) }}
        </template>

        <!-- <template v-for="key in Object.keys(item)" v-slot:item[key]="{ item }">
          <span
            v-if="
              key == 'Montant vente HT' ||
              key == 'TVA' ||
              key == 'Marge brute' ||
              key == 'Envoi de la vidéo le (4 mois avant):' ||
              key == 'Répertoire à demander le (2 mois avant):' ||
              key == 'Check prestataire son le (6 semaines avant):' ||
              key == 'Répertoire envoyé au groupe le (un mois avant):' ||
              key == 'FDR transmise et archivée avant le (3 semaines avant):' ||
              key == 'Envoi SMS check chefs d\'équipe le (3-4 jours avant):'
            "
            >{{ calcul(key, item) }}</span
          >
        </template> -->

        <template v-slot:header="{ props }">
          <thead v-if="!props.mobile">
            <tr>
              <th v-for="(header, index) in props.headers" :key="header.text" class="text-center">
                <!-- {{ headers[index].value }}
                {{ headers[index].filter }} -->
                <v-menu
                  v-if="
                    header.value !== 'shorts' &&
                    header.value !== 'Montant vente HT' &&
                    header.value !== 'TVA' &&
                    header.value !== 'Marge brute' &&
                    header.value !== 'Envoi de la vidéo le (4 mois avant):' &&
                    header.value !== 'Répertoire à demander le (2 mois avant):' &&
                    header.value !== 'Check prestataire son le (6 semaines avant):' &&
                    header.value !== 'Répertoire envoyé au groupe le (un mois avant):' &&
                    header.value !== 'FDR transmise et archivée avant le (3 semaines avant):' &&
                    header.value !== 'Envoi SMS check chefs d\'équipe le (3-4 jours avant):'
                  "
                  offset-y
                  :close-on-content-click="false"
                  v-model="menu[header.value]"
                  max-width="200"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on" icon x-small>
                      <v-icon :color="getFilterColor(header.value)">mdi-filter-variant</v-icon>
                    </v-btn>
                  </template>
                  <v-card width="200">
                    <v-divider></v-divider>

                    <v-text-field
                      dense
                      class="px-2"
                      outlined
                      append-icon="mdi-magnify"
                      v-model="serchInput[header.text]"
                    ></v-text-field>
                    <a class="text-caption ml-2" @click="effacerTout(header.text)">
                      Tout effacer
                    </a>
                    <a class="text-caption ml-2" @click="selectionerTout(header.text)">
                      Tout selectioner
                    </a>

                    <v-list flat style="max-height: 400px; overflow: auto">
                      <!-- <v-virtual-scroll
                        v-if="arraySelectedFilters[header.text] !== undefined"
                        :bench="0"
                        :items="
                          arraySelectedFilters[header.text].filter((e) => {
                            var sercheKey = serchInput[header.text];
                            if (sercheKey == '' || sercheKey == undefined) return true;
                            return e.toLowerCase().indexOf(sercheKey.toLowerCase()) !== -1;
                          })
                        "
                        height="300"
                        item-height="33"
                      > -->
                      <v-virtual-scroll
                        v-if="arraySelectedFilters[header.text] !== undefined"
                        :bench="0"
                        :items="
                          arraySelectedFilters[header.text]
                            .filter(headers[index].filterList)
                            .filter((e) => {
                              return (
                                serchInput[header.text] == '' ||
                                serchInput[header.text] == undefined ||
                                e.toLowerCase().indexOf(serchInput[header.text].toLowerCase()) !==
                                  -1
                              );
                            })
                        "
                        height="300"
                        item-height="33"
                      >
                        <template v-slot:default="{ item }">
                          <v-list-item-group v-model="arraySelectedFilters2[header.text]" multiple>
                            <v-list-item
                              dense
                              :key="item + header.text"
                              :value="item"
                              v-if="
                                serchInput[header.text] == '' ||
                                serchInput[header.text] == undefined ||
                                item
                                  .toLowerCase()
                                  .indexOf(serchInput[header.text].toLowerCase()) !== -1
                              "
                            >
                              <template v-slot:default="{ active = true }">
                                <v-list-item-action>
                                  <v-checkbox
                                    x-small
                                    :input-value="active"
                                    color="primary"
                                  ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content class="pa-0">
                                  <v-list-item-subtitle class="text">
                                    {{ item }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-list-item>
                          </v-list-item-group>
                        </template>
                      </v-virtual-scroll>
                    </v-list>

                    <v-btn text color="green" @click="menu[header.value] = false"> ok </v-btn>
                  </v-card>
                </v-menu>
              </th>
            </tr>
          </thead>
          <!-- <v-text-field
            v-else
            v-model="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field> -->
        </template>
        <!-- </template> -->
      </v-data-table>
    </template>
    <v-dialog v-model="dialog" width="1200" persistent @keydown.esc="dialog = false">
      <v-card elevation="2" class="pb-8">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loadingUpdate"
            @click="saveData(traitementData(visibleRow, ids))"
            dark
            color="blue"
            class="mr-7"
            small
          >
            enregistrer</v-btn
          >
          <v-btn @click="dialog = false" dark color="blue" icon>
            <v-icon>mdi-close-circle</v-icon></v-btn
          >
        </v-card-actions>
        <v-card-text>
          <v-row>
            <template v-for="(kk, ik) in formKeys">
              <v-col :key="ik" :cols="calculateRows(kk)">
                <v-textarea
                  class="text-wrap"
                  style="max-width: 100% !important"
                  auto-grow
                  rows="1"
                  hide-details="auto"
                  outlined
                  :messages="kk"
                  v-bind:value="visibleRow[kk]"
                  v-on:input="saveChangeDebounce($event, kk)"
                  required
                ></v-textarea>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" width="90%" scrollable persistent @keydown.esc="dialog2 = false">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loadingUpdate"
            @click="saveData(traitementData(visibleRow, ids))"
            dark
            color="blue"
            class="mr-7"
            small
          >
            enregistrer</v-btn
          >
          <v-btn @click="dialog2 = false" dark color="blue" icon>
            <v-icon>mdi-close-circle</v-icon></v-btn
          >
        </v-card-actions>
        <v-card-text style="height: 100%" class="mb-8">
          <v-expansion-panels flat multiple v-model="panel" @change="savePanelConfig">
            <v-expansion-panel v-for="(cat2, c2) in dataCat2" :key="c2">
              <v-expansion-panel-header class="blue--text text--darken-4" style="font-size: 30px">
                {{ c2 }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <template v-for="(idCat, ikc) in cat2">
                    <v-col :key="ikc + c2" :cols="calculateRows2(idCat.header)">
                      <v-tooltip bottom :disabled="idCat.lab == ''">
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-if="
                              idCat.header == 'Montant vente HT' ||
                              idCat.header == 'TVA' ||
                              idCat.header == 'Marge brute' ||
                              idCat.header == 'Envoi de la vidéo le (4 mois avant):' ||
                              idCat.header == 'Répertoire à demander le (2 mois avant):' ||
                              idCat.header == 'Check prestataire son le (6 semaines avant):' ||
                              idCat.header == 'Répertoire envoyé au groupe le (un mois avant):' ||
                              idCat.header ==
                                'FDR transmise et archivée avant le (3 semaines avant):' ||
                              idCat.header ==
                                'Envoi SMS check chefs d\'équipe le (3-4 jours avant):'
                            "
                          >
                            <v-textarea
                              dense
                              :readonly="false"
                              class="text-wrap"
                              style="max-width: 100% !important"
                              auto-grow
                              rows="1"
                              hide-details="auto"
                              :outlined="true"
                              :messages="idCat.header"
                              v-bind:value="visibleRow[idCat.header]"
                              v-on:input="saveChangeDebounce($event, idCat.header)"
                              v-bind="attrs"
                              v-on="on"
                              required
                            ></v-textarea>
                            <span v-if="String(visibleRow[idCat.header]).indexOf('=') !== -1">
                              {{ calcul(idCat.header, visibleRow) }}
                            </span>
                          </div>
                          <div
                            v-else-if="
                              idCat.header == 'Précisions' ||
                              idCat.header == 'Précisions du BDC pour la FDR : '
                            "
                          >
                            <v-textarea
                              dense
                              :readonly="false"
                              class="text-wrap"
                              style="max-width: 100% !important"
                              auto-grow
                              rows="1"
                              hide-details="auto"
                              :outlined="true"
                              :messages="idCat.header"
                              v-bind:value="visibleRow[idCat.header]"
                              v-on:input="saveChangeDebounce($event, idCat.header)"
                              v-bind="attrs"
                              v-on="on"
                              required
                            ></v-textarea>
                            <div v-if="urlify(visibleRow[idCat.header]) !== ''">
                              <a
                                :href="urlify(visibleRow[idCat.header])"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <a
                                  :href="urlify(visibleRow[idCat.header])"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {{ urlify(visibleRow[idCat.header]) }}
                                </a>
                              </a>
                            </div>
                          </div>
                          <div v-else>
                            <v-textarea
                              dense
                              :readonly="idCat.header == 'id'"
                              class="text-wrap"
                              style="max-width: 100% !important"
                              auto-grow
                              rows="1"
                              hide-details="auto"
                              :outlined="true"
                              :messages="idCat.header"
                              v-bind:value="visibleRow[idCat.header]"
                              v-bind="attrs"
                              v-on="on"
                              v-on:input="saveChangeDebounce($event, idCat.header)"
                              required
                            ></v-textarea>
                            <span v-if="String(visibleRow[idCat.header]).indexOf('=') !== -1">
                              {{ evaluateFormula(visibleRow[idCat.header]) }}
                            </span>
                            <!-- eeeeeeeeeeeeeeeeee -->
                            <!-- <v-textarea
                              v-if="String(visibleRow[idCat.header]).indexOf('=') !== -1"
                              @dblclick="enableReadOnly(ikc + c2)"
                              v-click-outside="disableReadOnly(ikc + c2)"
                              dense
                              :readonly="textEnable[ikc + c2]"
                              class="text-wrap"
                              style="max-width: 100% !important"
                              auto-grow
                              rows="1"
                              hide-details="auto"
                              :outlined="true"
                              :messages="idCat.header"
                              v-bind:value="evaluateFormula(visibleRow[idCat.header])"
                              v-bind="attrs"
                              required
                            ></v-textarea> -->
                          </div>
                        </template>

                        <span>{{ idCat.lab }}</span>
                      </v-tooltip>
                    </v-col>
                  </template>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { getDatabase, ref, child, get } from "firebase/database";
import { formatInTimeZone } from "date-fns-tz";
// import { formatInTimeZone } from "date-fns-tz";
import { debounce } from "debounce";
import { evaluate } from "mathjs";

export default {
  data() {
    return {
      montantVente: "Montant vente HT",
      tva: "TVA",
      margeBrute: "Marge brute",
      envoi4mois: "Envoi de la vidéo le (4 mois avant):",
      envoi2mois: "Répertoire à demander le (2 mois avant):",
      envoi6semaine: "Check prestataire son le (6 semaines avant):",
      envoi1mois: "Répertoire envoyé au groupe le (un mois avant):",
      envoi3semaine: "FDR transmise et archivée avant le (3 semaines avant):",
      envoi3jours: "Envoi SMS check chefs d'équipe le (3-4 jours avant):",
      panel: [0, 2, 1, 3, 4, 5, 6],
      dataTable: [],
      search: "",
      table: "Mariages, répétitions et techn",
      loadingUpdate: false,
      serchInput: {},
      dataFcTest: ["hey", "ho"],
      loading: true,
      yearFilter: "",
      menu: [],
      arrayFilter: {},
      arraySelectedFilters: {},
      arraySelectedFilters2: {},
      selected: [],
      dialog: false,
      dialog2: false,
      switch1: true,
      DataKeys: [],
      visibleRow: [],
      dataFc: [],
      originalDataFc: [],
      dataCat: [],
      dataCat2: [],
      ids: [],
      parisTime: "",
      bangkokTime: "",
      vegasTime: "",

      url: "https://script.google.com/macros/s/AKfycbwIjT1OSz4z7W8uh0hUYR6OHw7o2YfSYZlLuBREHJZnUYfoLnbyJlI7ImlmLX73-w6Y6w/exec",
      urlBcd:
        "https://script.google.com/macros/s/AKfycbxmvEnkdzCChrQ2SpD_A_UVx4QybDiiekE_gkVfrN2PZxgVByRuNPIUO3RtVM7AjDPo/exec",
      nbBcdCer: 0,
      nbBcdObs: 0,
      textEnable: {},
    };
  },

  methods: {
    urlify(text) {
      if (text == undefined) return;
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      if (text.match(urlRegex) == null) return "";
      return text.match(urlRegex)[0];
    },
    enableReadOnly(e) {
      this.textEnable[e] = true;
    },
    disableReadOnly(e) {
      console.log(e);
      console.log(this.textEnable);
      console.log(this.textEnable[e]);
      // this.$set(this.textEnable, e, false);
    },
    console(e) {
      this.textEnable[e] == true ? (this.textEnable[e] = false) : (this.textEnable[e] = true);
      console.log(this.textEnable);
    },
    calcul(header, row) {
      // console.log("header", header);
      // console.log("row", row);
      if (String(row[header]).charAt(0) !== "=") return row[header];
      var res = "l'expression n'a pas pu être évaluée";
      var dateDeLaPrestation = row["Date de la prestation"];
      if (header == "Montant vente HT") {
        res = Number(row["Tarif de vente TTC"] / 1.055).toFixed(2);
      } else if (header == "TVA") {
        res = Number(row["Tarif de vente TTC"] - row["Tarif de vente TTC"] / 1.055).toFixed(2);
      } else if (header == "Marge brute") {
        var montantVenteHt = row["Tarif de vente TTC"] / 1.055;
        var restmp =
          montantVenteHt -
          this.evaluateFormula(row["Total salaires, dpl, repas, sono,  hébergement, locations"]) -
          row["Frais FDR"];
        res = Number(restmp).toFixed(2);
      } else if (header == "Envoi de la vidéo le (4 mois avant):") {
        res = this.subStrDate(dateDeLaPrestation, -120);
      } else if (header == "Répertoire à demander le (2 mois avant):") {
        res = this.subStrDate(dateDeLaPrestation, -60);
      } else if (header == "Check prestataire son le (6 semaines avant):") {
        res = this.subStrDate(dateDeLaPrestation, -42);
      } else if (header == "Répertoire envoyé au groupe le (un mois avant):") {
        res = this.subStrDate(dateDeLaPrestation, -30);
      } else if (header == "FDR transmise et archivée avant le (3 semaines avant):") {
        res = this.subStrDate(dateDeLaPrestation, -10);
      } else if (header == "Envoi SMS check chefs d'équipe le (3-4 jours avant):") {
        res = this.subStrDate(dateDeLaPrestation, -4);
      }
      return String(res).indexOf("NaN") !== -1 ? "" : res;
    },
    subStrDate(dateStr = "04/03/2023", daysToSub = -1) {
      var [d, m, y] = dateStr.split("/");
      var day = Number(d);
      var monthIndex = Number(Number(m) - 1);
      var year = Number(y);
      var date = new Date(year, monthIndex, day);
      date.setDate(date.getDate() + daysToSub);
      // const [newYear, newMonth, newDay] = [
      //   date.getUTCFullYear(),
      //   ("0" + (date.getUTCMonth() + 1)).slice(-2),
      //   ("0" + date.getUTCDate()).slice(-2),
      // ];
      const [newYear, newMonth, newDay] = [
        date.getFullYear(),
        ("0" + (date.getMonth() + 1)).slice(-2),
        ("0" + date.getDate()).slice(-2),
      ];
      return newDay + "/" + newMonth + "/" + newYear;
    },
    evaluateFormula(str) {
      var newStr = JSON.parse(JSON.stringify(str));
      newStr = String(newStr).replace("=", "").replaceAll(",", ".");
      // console.log(newStr);
      var res = "l'expression n'a pas pu être évaluée";
      try {
        res = evaluate(newStr);
        return res;
      } catch (error) {
        // console.log(error);
        return res;
      }
    },
    savePanelConfig(e) {
      console.log(JSON.stringify(e));
      localStorage.setItem("savedPanel", JSON.stringify(e));
    },
    getPanelConfig() {
      this.panel =
        JSON.parse(localStorage.getItem("savedPanel")) == null
          ? [0, 2, 1, 3, 4, 5, 6]
          : JSON.parse(localStorage.getItem("savedPanel"));
    },
    goToBDC(path) {
      localStorage.setItem("savedFilters", JSON.stringify(this.arraySelectedFilters2));
      // localStorage.setItem("savedFilters", "[]");
      // console.log(path);
      this.$router.push(path);
    },
    // changeInTable() {
    //   console.log("change in table");
    // },
    //    saveChange(visibleRow[kk], $event);
    // debounce((value) => {
    //   visibleRow[kk] = $event;
    // }, 300);
    initAll() {
      this.arraySelectedFilters2 = [];
      console.log("initAll");
      document.location.reload();
    },
    // saveChangeDebounce: debounce(function (event, kk) {
    //   this.visibleRow[kk] = event;
    //   this.initAllSelectableData2(this.getSelectableItems());
    //   console.log("save");
    //   this.arraySelectedFilters2[kk].push(event);
    // }, 300),
    saveChangeDebounce: debounce(function (event, kk) {
      this.visibleRow[kk] = event;
      this.initAllSelectableData2(this.getSelectableItems());
      if (this.arraySelectedFilters2[kk] == undefined) {
        this.arraySelectedFilters2[kk] = [];
      }
      this.arraySelectedFilters2[kk].push(event);
    }, 500),
    updateSelectableItems() {
      // var refDataTable = this.$refs.dataTable;
      // var data = refDataTable.selectableItems;
      // console.log(refDataTable);
      // this.$set(this.arraySelectedFilters2, "Date de la prestation", undefined);
      var data = this.dataFc.filter((e) => {
        var date = e["Date de la prestation"];
        if (e == undefined) {
          return true;
        }
        if (this.yearFilter == "" || this.yearFilter == undefined) {
          return true;
        }
        if (this.yearFilter == "" || this.yearFilter == undefined) {
          return true;
        }
        var fullYearStr = this.yearFilter;
        var shortYearStr = fullYearStr.slice(-2);
        // console.log(value);
        if (String(date).indexOf("/" + shortYearStr) !== -1) return true;
        if (String(date).indexOf(fullYearStr) !== -1) return true;
        return false;
      });
      if (data) {
        this.initAllSelectableData(data);
      }
    },
    updateSelectableItems2() {
      var data = this.dataFc.filter((e) => {
        var date = e["Date de la prestation"];
        if (e == undefined) {
          return true;
        }
        if (this.yearFilter == "" || this.yearFilter == undefined) {
          return true;
        }
        if (this.yearFilter == "" || this.yearFilter == undefined) {
          return true;
        }
        var fullYearStr = this.yearFilter;
        var shortYearStr = fullYearStr.slice(-2);
        if (String(date).indexOf("/" + shortYearStr) !== -1) return true;
        if (String(date).indexOf(fullYearStr) !== -1) return true;
        return false;
      });
      if (data) {
        this.initAllSelectableData2(data);
      }
    },
    getSelectableItems() {
      // var refDataTable = this.$refs.dataTable;
      // var data = refDataTable.selectableItems;
      // console.log(refDataTable);
      // this.$set(this.arraySelectedFilters2, "Date de la prestation", undefined);
      var data = this.dataFc.filter((e) => {
        var date = e["Date de la prestation"];
        if (e == undefined) {
          return true;
        }
        if (this.yearFilter == "" || this.yearFilter == undefined) {
          return true;
        }
        if (this.yearFilter == "" || this.yearFilter == undefined) {
          return true;
        }
        var fullYearStr = this.yearFilter;
        var shortYearStr = fullYearStr.slice(-2);
        // console.log(value);
        if (String(date).indexOf("/" + shortYearStr) !== -1) return true;
        if (String(date).indexOf(fullYearStr) !== -1) return true;
        return false;
      });
      return data;
    },

    setIdFilter() {
      // var ids = this.arraySelectedFilters.id.filter((e) => {
      //   return e !== "" && e !== " " && e !== "/";
      // });
      // this.$set(this.arraySelectedFilters2, "id", ids);
      // this.arraySelectedFilters2.id = ids;
      var res = this.originalDataFc.filter((e) => {
        var id = e["id"];
        return id !== "" && id !== " " && id !== "/";
      });
      this.dataFc = JSON.parse(JSON.stringify(res));
      // this.dataFc =
    },
    close(e) {
      console.log(e);
    },
    changeTable(e) {
      console.log(e);
      this.getData();
    },
    getFilterColor(a) {
      if (this.arraySelectedFilters2[a] == undefined) return;
      if (this.arraySelectedFilters2[a].length == 0) return;
      if (this.arraySelectedFilters2[a].length == this.arraySelectedFilters[a].length) return;
      return "red";
    },
    traitementData(d, ids) {
      var dataRes = {};
      var array = ids.map((e) => e.header);
      for (var i in d) {
        if (array.indexOf(i) !== -1) {
          dataRes[i] = d[i];
        }
      }
      return dataRes;
    },
    async saveDataGet(d) {
      // this.initAllSelectableData2(this.dataFc);
      console.log(d);
      this.loadingUpdate = true;
      var url = this.$store.state.urlFc;
      var action = "update";
      var table = this.table;
      var id = d.id;
      var data = JSON.stringify(d);
      if (id == "") {
        window.alert(
          "les données n'ont pas pu être enregistrées car il n'y a pas d'identifiant attribué à ce plan, veuillez lui attribuer un identifiant manuellement à partir de la fiche client"
        );
        this.loadingUpdate = false;
        return;
      }

      var querry =
        url +
        "?action=" +
        action +
        "&table=" +
        table +
        "&id=" +
        id +
        "&data=" +
        encodeURIComponent(data);
      console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        if (da.success == true) {
          console.log(da);
        } else {
          if (da.id) window.alert("les données n'ont pas pu être enregistrées\nerror : ", da);
          console.log("error", da);

          window.alert(`error : ${da} `);
        }
      } catch (err) {
        console.log(`error : ${err} `);

        window.alert(`error : ${err} `); // TypeError: failed to fetch
      }
      this.loadingUpdate = false;
    },
    async saveData(d) {
      console.log(d);
      this.loadingUpdate = true;

      const url = this.$store.state.urlFc;
      const action = "update";
      const table = this.table;
      const id = d.id;

      if (!id) {
        window.alert(
          "Les données n'ont pas pu être enregistrées car il n'y a pas d'identifiant attribué à ce plan, veuillez lui attribuer un identifiant manuellement à partir de la fiche client."
        );
        this.loadingUpdate = false;
        return;
      }

      try {
        const response = await fetch(url, {
          method: "POST",
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "same-origin", // include, *same-origin, omit
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify({
            action: action,
            table: table,
            id: id,
            data: d,
          }),
        });

        const da = await response.json();

        if (da.success === true) {
          console.log("Données enregistrées avec succès :", da);
        } else {
          console.error("Erreur lors de l'enregistrement :", da);
          window.alert(
            "Les données n'ont pas pu être enregistrées.\nErreur : " + JSON.stringify(da)
          );
        }
      } catch (err) {
        console.error("Erreur de requête :", err);
        window.alert("Erreur de requête : " + err);
      }

      this.loadingUpdate = false;
    },
    filterYear(year = 2022) {
      year = parseInt(year);
      var res = this.originalDataFc.filter((e) => {
        var date = e["Date de la prestation"];
        var da = new Date(date);
        if (isNaN(da.getUTCFullYear())) {
          return date.indexOf(year) !== -1;
        }
        return da.getUTCFullYear() == year;
      });
      this.dataFc = JSON.parse(JSON.stringify(res));
      // this.dataFc =
    },
    removeAllFilters() {
      this.yearFilter = "";
      this.arraySelectedFilters2 = {};
      this.dataFc = JSON.parse(JSON.stringify(this.originalDataFc));
    },
    selectionerTout(key) {
      // arraySelectedFilters2[header.text]
      // console.log(this.arraySelectedFilters[key]);
      // this.$set(
      //   this.arraySelectedFilters,
      //   key,
      //   this.originalDataFc.map((e) => e[key]).filter(this.onlyUnique)
      // );
      this.$set(this.arraySelectedFilters2, key, this.arraySelectedFilters[key]);
      // console.log(this.arraySelectedFilters[key]);
    },
    effacerTout(key) {
      console.log(key);
      this.$set(this.arraySelectedFilters2, key, []);
    },
    filterPropositions(e, data, key) {
      console.log(e);
      var res = data.filter(function (str) {
        str = str.toString();
        return str.toLowerCase().indexOf(e.toLowerCase()) !== -1;
      });
      this.$set(this.arrayFilter, key, res);
      console.log(this.arrayFilter[key]);
    },
    getAllSelectableData(data, key) {
      console.log("data :", data);
      console.log("key :", key);
      var onlyUnique = data.map((e) => e[key]).filter(this.onlyUnique);
      console.log(this.arraySelectedFilters.key);
      return onlyUnique;
    },
    initAllSelectableData(data) {
      var keys = undefined;
      if (data.length < 1) {
        keys = Object.keys(this.arraySelectedFilters);
        keys.forEach((key) => {
          this.$set(this.arraySelectedFilters, key, []);
          this.$set(this.arraySelectedFilters2, key, []); // init selectedData
        });
      } else {
        keys = Object.keys(data[0]);
        keys.forEach((key) => {
          var onlyUnique = data.map((e) => e[key]).filter(this.onlyUnique);
          this.$set(this.arraySelectedFilters, key, onlyUnique);
          this.$set(this.arraySelectedFilters2, key, onlyUnique); // init selectedData
        });
      }
    },
    initAllSelectableData2(data) {
      var keys = undefined;
      if (data.length < 1) {
        keys = Object.keys(this.arraySelectedFilters);
        keys.forEach((key) => {
          this.$set(this.arraySelectedFilters, key, []);
          // this.$set(this.arraySelectedFilters2, key, []); // init selectedData
        });
      } else {
        keys = Object.keys(data[0]);
        keys.forEach((key) => {
          var onlyUnique = data.map((e) => e[key]).filter(this.onlyUnique);
          this.$set(this.arraySelectedFilters, key, onlyUnique);
          // this.$set(this.arraySelectedFilters2, key, onlyUnique); // init selectedData
        });
      }
    },
    filter(e, key) {
      console.log(e);
      var res = this.originalDataFc.filter(function (itm) {
        return e.indexOf(itm[key]) > -1;
      });
      this.dataFc = JSON.parse(JSON.stringify(res));
    },
    trierAZ(key) {
      this.dataFc.sort(function (a, b) {
        var x = null;
        var y = null;
        console.log(typeof a);
        typeof a[key] == "string" ? (x = a[key].toLowerCase()) : (x = a[key]);
        typeof b[key] == "string" ? (y = b[key].toLowerCase()) : (y = b[key]);
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    trierZA(key) {
      this.dataFc.sort(function (a, b) {
        var x = a[key].toLowerCase();
        var y = b[key].toLowerCase();
        return x > y ? -1 : x < y ? 1 : 0;
      });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    openForm(dataRow) {
      this.dialog = true;
      this.visibleRow = dataRow;
    },
    openForm2(dataRow, { item }) {
      this.dialog2 = true;
      this.visibleRow = item;
    },
    async getData() {
      // console.log("getData");
      await this.getDataKeys(this.user.email);
      var vm = this;
      this.loading = true;
      var url = this.$store.state.urlFc;
      var action = "read2";
      var range = this.table + "!1:650";
      var querry = url + "?action=" + action + "&range=" + range;
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        if (da.success == true) {
          vm.dataFc = da.data;
          vm.originalDataFc = JSON.parse(JSON.stringify(da.data));
          var data = JSON.parse(JSON.stringify(da.data));
          // console.log(data);
          // console.log(Object.keys(data[0]));
          var savedFilters =
            JSON.parse(localStorage.getItem("savedFilters")) == null
              ? []
              : JSON.parse(localStorage.getItem("savedFilters"));
          if (savedFilters.length < 1) {
            vm.initAllSelectableData(data);
          } else {
            // vm.initAllSelectableData2(data);
            this.arraySelectedFilters2 = savedFilters;
            this.updateSelectableItems2();
          }
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      this.getCatData();
      this.getCatData2();
      this.loading = false;
    },
    async getDataKeys(id) {
      var vm = this;
      // this.loading = true;
      var url = this.$store.state.urlFc;

      var action = "read";
      var table = "controleApp";
      var range = "A1:D10";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range + "&id=" + id;
      try {
        let response = await fetch(querry);
        let da = await response.json();
        // console.log("getDataKeys", da);
        // console.log("getDataKeys ID", id);
        if (da.success == true) {
          vm.DataKeys = da.data;
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      // this.loading = false;
    },
    async getCatData() {
      var vm = this;
      // this.loading = true;
      var url = this.$store.state.urlFc;
      var action = "read";
      var table = "controleAppCat";
      var range = "A1:B10";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        // console.log(da);

        if (da.success == true) {
          vm.dataCat = da.data;
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      // this.loading = false;
    },
    async getCatData2() {
      var vm = this;
      // this.loading = true;
      var url = this.$store.state.urlFc;
      var action = "read";
      var table = "controleAppCat";
      var range = "A1:C117";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        // console.log(da);

        if (da.success == true) {
          var d = da.data.filter((e) => e.cat !== "");
          vm.ids = d;
          vm.dataCat2 = groupBy(d, "cat");
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      // this.loading = false;
    },
    testIfitIsADate(date) {
      if (isNaN(Date.parse(date)) || String(date).length < 6) {
        //not a date
        return date;
      } else {
        // is a date => format
        return this.formatDate(date);
      }
    },
    formatDate(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${day}/${month}/${year}`;
    },
    formatDate2(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${year}-${month}-${day}`;
    },
    formatDate3(date) {
      if (!date) return null;
      var da = date;
      const [hours, minuts, seconds] = [
        da.getHours(),
        ("0" + (da.getMinutes() + 1)).slice(-2),
        ("0" + da.getSeconds()).slice(-2),
      ];
      return `${hours}:${minuts}:${seconds}`;
    },
    signOut() {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          window.alert("déconnexion réussie");
        })
        .catch((error) => {
          window.alert(`Erreur: ${error}`);
        });
    },
    updateClock() {
      var date = new Date();
      this.parisTime = formatInTimeZone(date, "Europe/Paris", "HH:mm");
      this.bangkokTime = formatInTimeZone(date, "Asia/Bangkok", "HH:mm");
      this.vegasTime = formatInTimeZone(date, "America/Los_Angeles", "HH:mm");
      requestAnimationFrame(this.updateClock);
    },
    calculateRows(kk) {
      if (window.innerWidth < 610) {
        return 12;
      }
      var a = this.visibleRow[kk];
      if (a == undefined) {
        return 6;
      }
      return a.toString().length > 300 ? 12 : 6;
    },
    calculateRows2(kk) {
      if (window.innerWidth < 610) {
        return 12;
      }
      var a = this.visibleRow[kk];
      if (a == undefined) {
        return 3;
      }
      return a.toString().length > 80 ? 12 : a.toString().length > 200 ? 6 : 3;
    },
    async getNbrBDCCer() {
      await this.getDataKeys(this.user.email);
      var vm = this;
      // this.loading = true;
      var url = this.urlBcd;
      var action = "read";
      var table = "bdd";
      var range = "F1:G";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        if (da.success == true) {
          // console.log(da.data);
          vm.nbBcdCer = da.data.filter((e) => {
            return e.e6 == 9 && e.copieDansFC !== true;
          }).length;
          // console.log("vm.nbBcdCer ", vm.nbBcdCer);
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      // this.loading = false;
      //   this.getCatData();
      //   this.getCatData2();
    },
    async getNbrBDCObs() {
      await this.getDataKeys(this.user.email);
      var vm = this;
      // this.loading = true;
      var url = this.urlBcd;
      var action = "read";
      var table = "bddObseques";
      var range = "F1:G";
      var querry = url + "?action=" + action + "&table=" + table + "&range=" + range;
      // console.log(querry);
      try {
        let response = await fetch(querry);
        // console.log(response);
        let da = await response.json();
        if (da.success == true) {
          // console.log("bddObseques", da.data);
          vm.nbBcdObs = da.data.filter((e) => {
            return e.e6 == 9 && e.copieDansFC !== true;
          }).length;
        }
      } catch (err) {
        alert(err); // TypeError: failed to fetch
      }
      // this.loading = false;
      //   this.getCatData();
      //   this.getCatData2();
    },
    calculateHeadersOptions(e) {
      var width = e == "shorts" ? "30px" : e == "id" ? "30px" : e == "shorts" ? "30px" : "150px";
      if (e == "Date de la prestation") {
        width = "100px";
      } else if (e == "Groupe") {
        width = "120px";
      } else if (e == "Lieu") {
        // console.log("Lieu", e);
        width = "100px";
      } else if (e == "Type de prestation") {
        width = "100px";
      } else if (e == "Mail") {
        width = "120px";
      }
      var sortable = e == "shorts" ? false : true;
      var filterFunction =
        e == "Date de la prestation"
          ? (value) => {
              // console.log(this.yearFilter);
              if (value == undefined) return true;
              if (this.yearFilter == "" || this.yearFilter == undefined) {
                if (!this.arraySelectedFilters2[e]) return true;
                if (this.arraySelectedFilters2[e].length == 0) {
                  // if (this.yearFilter !== "") {
                  //   var date = value;
                  //   var da = new Date(date);
                  //   var year = this.yearFilter;
                  //   if (isNaN(da.getUTCFullYear())) {
                  //     return date.indexOf(year) !== -1;
                  //   } else {
                  //     return da.getUTCFullYear() == year;
                  //   }
                  // }
                  return true;
                }
              } else {
                if (this.arraySelectedFilters2[e]) {
                  if (this.arraySelectedFilters2[e].indexOf(value) !== -1) return true;
                  return false;
                }
                //
                var fullYearStr = this.yearFilter;
                var shortYearStr = fullYearStr.slice(-2);
                // console.log(value);
                if (String(value).indexOf("/" + shortYearStr) !== -1) return true;
                if (String(value).indexOf(fullYearStr) !== -1) return true;
                return false;
              }
              if (this.arraySelectedFilters2[e].indexOf(value) !== -1) return true;
              return false;
            }
          : (value) => {
              if (value == undefined) return true;
              // return true;
              // return value < parseInt(this.calories);
              if (!this.arraySelectedFilters2[e]) return true;
              if (this.arraySelectedFilters2[e].length == 0) return true;
              if (this.arraySelectedFilters2[e].indexOf(value) !== -1) return true;
              return false;
            };
      var filterFunctionList =
        e == "Date de la prestation"
          ? (value) => {
              if (value == undefined) return true;
              if (this.yearFilter == "" || this.yearFilter == undefined) {
                if (!this.arraySelectedFilters2[e]) return true;
                if (this.arraySelectedFilters2[e].length == 0) {
                  return true;
                }
              } else {
                var fullYearStr = this.yearFilter;
                var shortYearStr = fullYearStr.slice(-2);
                // console.log(value);
                if (String(value).indexOf("/" + shortYearStr) !== -1) return true;
                if (String(value).indexOf(fullYearStr) !== -1) return true;
                return false;
              }
              if (this.arraySelectedFilters2[e].indexOf(value) !== -1) return true;
              return false;
            }
          : () => {
              return true;
            };
      return {
        text: e,
        value: e,
        align: "center",
        width: width,
        class: "myCellCenter",
        sortable: sortable,
        filter: filterFunction,
        filterList: filterFunctionList,
      };
    },
    updateData() {
      if (!this.dialog && !this.dialog2 && this.$route.name == "Accueil") {
        console.log("automaticUpdate");
        document.location.reload();
        // this.getData();
      }
    },
    // setUpdateEvery10Minuts() {
    //   var vm = this;
    //   console.log(this.$route.name);
    //   setInterval(function () {
    //     vm.updateData();
    //   }, 900 * 1000); // 60 * 1000 milsec  /// 15 min
    //   // }, 30000); // 60 * 1000 milsec  /// 0,5 min 30 s
    // },
  },
  computed: {
    testReadOnly(e) {
      return this.textEnable[e] ?? true;
    },
    keys() {
      return Object.keys(this.dataFc[0]);
    },
    user() {
      return JSON.parse(JSON.stringify(this.$store.state.currentUser.dataFromGoogleAuth));
    },
    headers() {
      if (this.DataKeys == undefined) return [];
      if (this.DataKeys.Tableau) {
        var keys = this.DataKeys.Tableau.split(",");
        // console.log("keys", keys);
        // console.log(keys.unshift("shorts"));
        keys.unshift("shorts");
        return keys.map((e) => {
          return this.calculateHeadersOptions(e);
        });
      } else {
        return [];
      }
    },
    formKeys() {
      if (this.DataKeys.Tableau) {
        return this.DataKeys.Formulaire.split(",");
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.getPanelConfig();
    this.debounce = debounce;
    document.title = "Tableau de bord";
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const dbRef = ref(getDatabase());
        get(child(dbRef, `users/${user.uid}`))
          .then((snapshot) => {
            if (snapshot.exists()) {
              var userData = snapshot.val();
              if (userData.status == "") {
                window.alert("Votre compte est en cours de validation ...");
                this.$router.push("/login");
              } else {
                this.$store.state.currentUser.status = userData.status;
                this.$store.state.currentUser.dataFromGoogleAuth = userData;
                this.getData();
                // this.setUpdateEvery10Minuts();
                this.getNbrBDCCer();
                this.getNbrBDCObs();
              }
            } else {
              console.log("userData");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.$router.push("/login");
      }
    });
    requestAnimationFrame(this.updateClock);
  },
  created() {
    var vm = this;
    window.onbeforeunload = function () {
      localStorage.setItem("savedFilters", JSON.stringify(vm.arraySelectedFilters2));
      localStorage.setItem("savedTable", JSON.stringify(vm.table));
      localStorage.setItem("yearFilter", JSON.stringify(vm.yearFilter));
    };
  },
  beforeMount() {
    var savedFilters = localStorage.getItem("savedFilters");
    // console.log(savedFilters);
    // console.log(typeof JSON.parse(savedFilters));
    if (savedFilters !== null && savedFilters !== "undefined") {
      savedFilters = JSON.parse(savedFilters);
      if (typeof savedFilters == "object") {
        this.arraySelectedFilters2 = savedFilters;
      }
    }
    var savedTable = localStorage.getItem("savedTable");
    if (savedTable !== null && savedTable !== "undefined") {
      savedTable = JSON.parse(savedTable);
      this.table = savedTable;
    }
    var yearFilter = localStorage.getItem("yearFilter");
    if (yearFilter !== null && yearFilter !== "undefined") {
      yearFilter = JSON.parse(yearFilter);
      this.yearFilter = yearFilter;
    }
  },
};
function groupBy(tableauObjets, propriete) {
  return tableauObjets.reduce(function (acc, obj) {
    var cle = obj[propriete];
    if (!acc[cle]) {
      acc[cle] = [];
    }
    acc[cle].push(obj);
    return acc;
  }, {});
}
</script>
<style>
.v-messages__message {
  color: #1565c0;
}
.colorTitle {
  color: #1a237e;
}
.bd-highlight {
  background-color: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.15);
}
.v-icon.v-icon {
  font-size: 20px !important;
}
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 11px !important;
}
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 5px !important;
}
.v-list-item__action {
  align-self: center;
  margin: 0px 0;
}
.v-list-item {
  padding: 0 6px;
}
.v-menu__content .theme--light .menuable__content__active {
  min-width: 197px !important;
}
.myCellCenter {
  padding-left: 10px;
  padding-right: 10px;
}
.myCellCenter span {
  /* background-color: blue;
  display: flex;
  flex-direction: column !important;
  align-items: center !important; */
  /* white-space: nowrap; */
  /* overflow-wrap: break-word; */
  display: inline-block;
  overflow-wrap: break-word !important;
  /* flex-direction: row !important; */
}
.v-data-table__mobile-table-row {
  margin-left: 10px;
  margin-right: 10px;
}
.v-data-table__mobile-row__cell {
  text-align: left !important;
  min-width: 200px;
}
.v-data-table-header-mobile__wrapper {
  margin-left: 10px;
  margin-right: 10px;
}
.v-select__selections input {
  display: none;
}
.text {
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
/* .v-select.v-input--is-dirty input {
  display: none;
}
.v-select__selection {
  max-width: none;
  margin: auto;
}
.v-select__selections {
  margin: auto;
}
.v-select.fit {
  width: min-content;
}
.v-select.fit .v-select__selection--comma {
  text-overflow: unset;
} */
</style>
